import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Chart } from '../index';
import styles from './ChartExamplesPage.module.css';
function generateMockChartData(days = 7) {
    const data = [];
    const today = new Date();
    for (let i = 0; i < days; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() - (days - 1 - i));
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}`;
        data.push({
            date: formattedDate,
            received: Math.floor(Math.random() * 5000) + 1000,
            pending: Math.floor(Math.random() * 7000) + 2000,
            overdue: Math.floor(Math.random() * 1000) + 100,
        });
    }
    return data;
}
export function ChartExamplesPage() {
    const [selectedExample, setSelectedExample] = useState('line-default');
    const chartData = useMemo(() => generateMockChartData(7), []);
    const chartConfigs = useMemo(() => {
        const baseData = {
            data: chartData,
            width: '100%',
            height: 350,
            xAxis: {
                dataKey: 'date',
                label: 'Data',
            },
            yAxis: {
                label: 'Valor (R$)',
            },
            tooltip: true,
            legend: false,
        };
        return {
            'line-default': {
                ...baseData,
                type: 'line',
                series: [
                    {
                        name: 'Recebidas',
                        dataKey: 'received',
                        stroke: '#387C2B',
                    },
                    {
                        name: 'Pendentes',
                        dataKey: 'pending',
                        stroke: '#1573D3',
                    },
                    {
                        name: 'Vencidas',
                        dataKey: 'overdue',
                        stroke: '#DC0A0A',
                    },
                ],
                colors: ['#387C2B', '#1573D3', '#DC0A0A'],
                theme: {
                    backgroundColor: 'var(--surface-neutral-dark, #1F1F1F)',
                },
            },
            'line-custom': {
                ...baseData,
                type: 'line',
                series: [
                    {
                        name: 'Recebidas',
                        dataKey: 'received',
                        stroke: '#FF6B6B',
                    },
                    {
                        name: 'Pendentes',
                        dataKey: 'pending',
                        stroke: '#4ECDC4',
                    },
                    {
                        name: 'Vencidas',
                        dataKey: 'overdue',
                        stroke: '#FFE66D',
                    },
                ],
                colors: ['#FF6B6B', '#4ECDC4', '#FFE66D'],
                theme: {
                    axis: {
                        x: { labelColor: '#000000' },
                        y: { labelColor: '#000000' },
                    },
                    legend: { show: true, textColor: '#000000' },
                },
            },
            bar: {
                ...baseData,
                type: 'bar',
                series: [
                    {
                        name: 'Recebidas',
                        dataKey: 'received',
                        stroke: '#387C2B',
                    },
                    {
                        name: 'Pendentes',
                        dataKey: 'pending',
                        stroke: '#1573D3',
                    },
                    {
                        name: 'Vencidas',
                        dataKey: 'overdue',
                        stroke: '#DC0A0A',
                    },
                ],
                colors: ['#387C2B', '#1573D3', '#DC0A0A'],
                legend: true,
                theme: {
                    legend: { show: true },
                },
            },
            area: {
                ...baseData,
                type: 'area',
                series: [
                    {
                        name: 'Recebidas',
                        dataKey: 'received',
                        stroke: '#387C2B',
                        fill: '#387C2B',
                    },
                    {
                        name: 'Pendentes',
                        dataKey: 'pending',
                        stroke: '#1573D3',
                        fill: '#1573D3',
                    },
                ],
                colors: ['#387C2B', '#1573D3'],
                legend: true,
                theme: {
                    legend: { show: true },
                },
            },
        };
    }, [chartData]);
    const currentConfig = chartConfigs[selectedExample];
    return (_jsxs("div", { className: styles.container, children: [_jsxs("div", { className: styles.header, children: [_jsx("h1", { className: styles.title, children: "Exemplos de Gr\u00E1ficos" }), _jsx("p", { className: styles.subtitle, children: "Demonstra\u00E7\u00E3o da arquitetura de gr\u00E1ficos desacoplada com Apache ECharts" })] }), _jsxs("div", { className: styles.content, children: [_jsx("div", { className: styles.controls, children: _jsxs("div", { className: styles.controlGroup, children: [_jsx("label", { htmlFor: 'chart-example-selector', className: styles.selectorLabel, children: "Exemplo:" }), _jsxs("select", { id: 'chart-example-selector', value: selectedExample, onChange: e => setSelectedExample(e.target.value), className: styles.select, "data-testid": 'chart-example-selector', children: [_jsx("option", { value: 'line-default', children: "Linha - Padr\u00E3o Figma" }), _jsx("option", { value: 'line-custom', children: "Linha - Cores Customizadas" }), _jsx("option", { value: 'bar', children: "Barras" }), _jsx("option", { value: 'area', children: "\u00C1rea" })] })] }) }), _jsx("div", { className: styles.chartContainer, children: _jsx(Chart, { config: currentConfig, "data-testid": 'billing-chart' }) }), _jsx("div", { className: styles.description, children: _jsxs("p", { className: styles.descriptionText, children: [selectedExample === 'line-default' &&
                                    'Gráfico de linha com tema padrão do Figma (fundo escuro, labels brancos, sem legenda)', selectedExample === 'line-custom' &&
                                    'Gráfico de linha com cores e tema customizados (labels pretos, com legenda)', selectedExample === 'bar' && 'Gráfico de barras com legenda habilitada', selectedExample === 'area' && 'Gráfico de área com duas séries'] }) })] })] }));
}
